import { createSharedComposable } from '@vueuse/core'

export const useImagePreview = createSharedComposable(() => {
  const state = reactive({
    show: false,
    type: 'main',
    index: 0
  })

  const open = (type, index) => {
    state.show = true
    state.type = type
    state.index = index
  }

  return {
    state,
    open
  }
})
